import React from 'react';
import Page from 'App/components/Page';
import { PERMISSION_TYPES } from 'App/utils/isPermitted';
import ContentPublisher from './ContentPublisher';

function ContentPublisherPage() {
    return (
        <Page title="Content Publisher" showPageTitle permissionType={PERMISSION_TYPES.CONTENT_PUBLISHER}>
            <ContentPublisher />
        </Page>
    );
}

export default ContentPublisherPage;
